var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagTurkey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16710)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.4316C24.8366 32.4316 32 25.2682 32 16.4316C32 7.59508 24.8366 0.431641 16 0.431641C7.16344 0.431641 0 7.59508 0 16.4316C0 25.2682 7.16344 32.4316 16 32.4316Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3449 13.5054L16.6577 15.3144L18.7838 14.6251L17.4689 16.4326L18.7815 18.2416L16.6562 17.5496L15.3414 19.3571L15.3428 17.122L13.2174 16.43L15.3435 15.7406L15.3449 13.5054Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7621 20.9532C9.26489 20.9532 7.24039 18.9287 7.24039 16.4315C7.24039 13.9342 9.26489 11.9097 11.7621 11.9097C12.5408 11.9097 13.2734 12.1066 13.913 12.4532C12.9096 11.4718 11.5373 10.8662 10.023 10.8662C6.94939 10.8662 4.45782 13.3578 4.45782 16.4314C4.45782 19.505 6.94945 21.9966 10.023 21.9966C11.5374 21.9966 12.9096 21.3909 13.913 20.4096C13.2734 20.7563 12.5408 20.9532 11.7621 20.9532Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16710"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.431641)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagTurkey);
export default __webpack_public_path__ + "static/media/flag_turkey.53058aa588e384a1fac34705139ca0ad.svg";
export { ForwardRef as ReactComponent };